module.exports = function() {
  return new Worker(__webpack_public_path__ + "93609c7a3ef353159f3e.worker.js");
};